import React from 'react';
import moment from 'moment';
const CCompanies = ({ companies = [] }) => {
  return (
    <div className="white-wraper extra-mt mob-margin">
      <h2 className="add-margin">Top Job Posting Companies ({companies?.[0]?.year ?? new Date().getFullYear()})</h2>
      <div className="chart-canvas2 ajtable-canvas">
        <div className="aj-table">
          <table className="table" id="activejobs-table">
            <thead>
              <tr>
                <th className='topjob-col1'>#</th>
                <th className='topjob-col2'>Company</th>
                <th className='topjob-col3'>Total Jobs</th>
                <th className='topjob-col4'>Jobs Completed</th>
                <th className='topjob-col5'>Completion %</th>
                <th className='topjob-col6'>Total Invoice</th>
                <th className='topjob-col7'>Invoice Received</th>
                <th className='topjob-col5'>Received %</th>
              </tr>
            </thead>
            <tbody>
              {companies.length > 0 ? (
                companies.map((company, idx) => (
                  <tr key={idx}>
                    <td className='topjob-col1'>{idx + 1}</td>
                    <td className='topjob-col2'>{company.company_name}</td>
                    <td className='topjob-col3'>{company.job_count || '-'}</td>
                    <td className='topjob-col4'>{company.jobs_completed  || '-'}</td>
                    <td className='topjob-col5'>{isNaN(parseFloat(company.completion_perc)) ? '-' : parseFloat(company.completion_perc).toFixed(2)}</td>
                    <td className='topjob-col6'>{company.hs_invoice_count}</td>
                    <td className='topjob-col7'>{company.hs_invoice_paid_count}</td>
                    <td className='topjob-col5'>{isNaN(parseFloat(company.payment_perc)) ? '-' : parseFloat(company.payment_perc).toFixed(2)}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="8" className="text-center text-secondary border-none" style={{ paddingTop: "4rem", paddingBottom: "3rem" }}>No data available</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default CCompanies;